/* NDC · Fase 5 · Club: CTA flotante (IntersectionObserver), chip del plan en registro, validación del formulario de regalo antes del AJAX de Flex,
   eventos GA4 (dataLayer). Vanilla, defer. */
(function () {
  'use strict';
  var track = function (payload) { try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) {} };

  /* ---------- CTA flotante "Ver los planes" (barra < 1024 px, píldora ≥ 1024 px) ----------
     Aparece cuando el botón del hero sale del viewport; se oculta mientras el hero, #unirme (o los selectores de
     data-hide-when) están a la vista. En móvil también se oculta sobre los bloques [data-ndc-sticky-hide] (regalo). */
  var bar = document.querySelector('[data-ndc-sticky-cta]');
  if (bar) {
    var hideSel = bar.getAttribute('data-hide-when') || '#club-hero, #unirme';
    var hero = document.querySelector('[data-ndc-club-hero]');
    var heroCta = hero && hero.querySelector('.ndc-btn');
    var always = [];
    try { always = Array.prototype.slice.call(document.querySelectorAll(hideSel)); } catch (e) { always = []; }
    if (heroCta) always.push(heroCta); else if (hero) always.push(hero);
    var mobileOnly = Array.prototype.slice.call(document.querySelectorAll('[data-ndc-sticky-hide]'));
    var targets = always.slice();
    mobileOnly.forEach(function (t) { if (targets.indexOf(t) === -1) targets.push(t); });
    var visible = {};
    var mqDesk = window.matchMedia('(min-width: 1024px)');
    var update = function () {
      var hide = targets.length === 0;
      targets.forEach(function (t, i) {
        if (!visible[i]) return;
        if (mqDesk.matches && always.indexOf(t) === -1) return; // en desktop solo cuentan hero/#unirme/hide_when
        hide = true;
      });
      bar.classList.toggle('is-hidden', hide);
      bar.setAttribute('aria-hidden', hide ? 'true' : 'false');
      document.body.classList.toggle('ndc-sticky-visible', !hide);
    };
    if ('IntersectionObserver' in window && targets.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { visible[targets.indexOf(en.target)] = en.isIntersecting; });
        update();
      }, { threshold: 0 });
      targets.forEach(function (t) { io.observe(t); });
    } else {
      // Sin IO: mostrar tras el primer scroll
      window.addEventListener('scroll', function () { visible[0] = window.scrollY < 400; update(); }, { passive: true });
      visible[0] = true; update();
    }
    var onMq = function () { update(); };
    mqDesk.addEventListener ? mqDesk.addEventListener('change', onMq) : mqDesk.addListener(onMq);
  }

  /* ---------- Chip del plan elegido en /pages/club-registro (lee ?plan= de la URL; valores permitidos) ---------- */
  var chip = document.querySelector('[data-ndc-plan]');
  if (chip) {
    try {
      var plans = JSON.parse(chip.getAttribute('data-ndc-plans') || '{}');
      var q = new URLSearchParams(window.location.search);
      var wanted = (q.get('plan') || q.get('field67285091') || '').toLowerCase();
      var info = plans[wanted];
      if (info) {
        chip.textContent = '';
        var b = document.createElement('b'); b.textContent = info.name;
        chip.appendChild(b);
        chip.appendChild(document.createTextNode(' · S/ ' + info.price + ' al mes'));
        chip.setAttribute('data-plan', wanted);
        chip.classList.add('is-set');
        track({ event: 'club_registro_view', plan: wanted });
      }
    } catch (e) { /* se queda el texto de servidor "Plan elegido" */ }
  }

  /* ---------- Regalo: validar antes de que el AJAX de Flex capture el clic ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ndc-gift] .ajax-submit');
    if (!btn) return;
    var form = btn.closest('form');
    if (form && typeof form.checkValidity === 'function' && !form.checkValidity()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (form.reportValidity) form.reportValidity();
      return;
    }
    track({ event: 'gift_add_to_cart', plan: btn.getAttribute('data-plan') || 'oro', months: 3 });
  }, true);

  /* ---------- Eventos GA4 ---------- */
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-ndc-track]');
    if (!el || el.classList.contains('ajax-submit')) return;
    var ev = el.getAttribute('data-ndc-track');
    var payload = { event: ev };
    if (el.getAttribute('data-plan')) payload.plan = el.getAttribute('data-plan');
    if (el.getAttribute('data-ndc-place')) payload.place = el.getAttribute('data-ndc-place');
    track(payload);
  });

  /* ---------- Ancla suave a #planes (respeta reduced-motion) ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.ndc-clubpage a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    var target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });
})();
